module.exports = __webpack_public_path__ + "static/mobile-food-83d285508fd8d9b546cb9dee1b7ea828.jpg";